import { render, staticRenderFns } from "./shangban.vue?vue&type=template&id=4f782174&scoped=true&"
import script from "./shangban.vue?vue&type=script&lang=js&"
export * from "./shangban.vue?vue&type=script&lang=js&"
import style0 from "./shangban.vue?vue&type=style&index=0&id=4f782174&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f782174",
  null
  
)

export default component.exports